import { risapi, getAxiosConfig, getAPIFullUrl, handleApiError } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

export const getDocuments = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/documents', filters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error: error });
    }
};

// This function makes the call to the controller's "show" method
export const fetchDocument = async (id, callback) => {
    try {
        const response = await risapi.get(`/api/documents/${id}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error: error });
    }
};

export const createDocument = async (document, callback) => {
    try {
        const formData = convertJsonToFormData(document);
        const headers = getAxiosConfig();
        headers.headers['Content-Type'] = 'multipart/form-data';
        
        const response = await risapi.post('/api/documents', formData, headers);
        if (response.status === 201) {
            callback({ document: response.data.document });
        }
    } catch (error) {
        callback({ error: error });
    }
};

export const updateDocument = async (document, callback) => {
    try {
        const formData = convertJsonToFormData(document);
        formData.append('_method', 'put');
        const headers = getAxiosConfig();
        headers.headers['Content-Type'] = 'multipart/form-data';
        
        const response = await risapi.post(`/api/documents/${document.id}`, formData, headers);
        if (response.status === 200) {
            callback({ document: response.data.document });
        }
    } catch (error) {
        callback({ error: error });
    }
};

export const destroyDocument = async (document, callback) => {
    try {
        await risapi.delete(`/api/documents/${document.id}`, getAxiosConfig());
        callback({ document: {} }); // Success
    } catch (error) {
        handleApiError(error);
        callback({ error: error });
    }
};

export const getDocumentsForDropdown = async (callback) => {
    try {
        const response = await risapi.get('/api/documents-list', getAxiosConfig());
        callback(response.data);
    } catch (error) {
        handleApiError(error);
        callback({ error: error });
    }
};

export const uploadDocumentImage = async (imageFile, callback) => {
    try {
        const formData = new FormData();
        formData.append('image', imageFile);
        const headers = getAxiosConfig();
        headers.headers['Content-Type'] = 'multipart/form-data';

        const response = await risapi.post('/api/documents/upload-image', formData, headers);
        callback(response.data);
    } catch (error) {
        callback({ error: error });
    }
};

export const searchDocuments = async (term, callback) => {
    try {
        const response = await risapi.get('/api/documents/search', {
            ...getAxiosConfig(),
            params: { term }
        });
        callback(response.data);
    } catch (error) {
        callback({ error });
    }
};

